/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { AbstractRestService, arrayOf, RestSettings } from '@gh/core-data';
import { Observable } from 'rxjs';
import { AccountingAccountDto, AccountingAccountFilterDto } from './accounting-account.dto';
import {
  AccountingAccountFilterMapper,
  AccountingAccountMapper,
} from './accounting-account.mapper';

@Injectable()
export class AccountingAccountRestService extends AbstractRestService {
  constructor(
    settings: RestSettings) {
    super(settings);
  }

  findAll(filter: AccountingAccountFilterDto): Observable<AccountingAccountDto[]> {
    return this.httpGet(
      `${this.accounting}/accounting/accounts`,
      filter,
      AccountingAccountFilterMapper,
      arrayOf(AccountingAccountMapper),
    );
  }
}
